var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 6.3V4.5C12.1875 1.98 10.125 0 7.5 0C4.875 0 2.8125 1.98 2.8125 4.5V6.3C1.21875 6.3 0 7.47 0 9V15.3C0 16.83 1.21875 18 2.8125 18H12.1875C13.7812 18 15 16.83 15 15.3V9C15 7.47 13.7812 6.3 12.1875 6.3ZM4.6875 4.5C4.6875 2.97 5.90625 1.8 7.5 1.8C9.09375 1.8 10.3125 2.97 10.3125 4.5V6.3H4.6875V4.5ZM8.53125 12.15L8.4375 12.24V13.5C8.4375 14.04 8.0625 14.4 7.5 14.4C6.9375 14.4 6.5625 14.04 6.5625 13.5V12.24C6 11.7 5.90625 10.89 6.46875 10.35C7.03125 9.81 7.875 9.72 8.4375 10.26C9 10.71 9.09375 11.61 8.53125 12.15Z",
    fill: "white",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockGray);
export default __webpack_public_path__ + "static/media/block-gray.9c59e9998c599c53d59a61e8da64accd.svg";
export { ForwardRef as ReactComponent };